'use client'
import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'

import { useParams } from 'next/navigation'
import fetchHotels, { QUERY_HOTEL_LIST_KEY } from './fetchHotels'
import useAuthentication from '../useAuthentication'
import type { HotelModel } from 'core/hotels/types'

function useQueryHotelList(
  areaId?: string | null,
): UseQueryResult<HotelModel[] | null | undefined> {
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}
  const { withTriplaApiRequest } = useAuthentication()

  return useQuery({
    queryKey: [QUERY_HOTEL_LIST_KEY, { areaId, locale }],
    queryFn: withTriplaApiRequest(fetchHotels),
  })
}

export default useQueryHotelList
